<template>
    <div class="yx-adopt-schoo-manager">
        <div class="site-manager-head-con clearfix">
                <div class="top-page-top fl">
                    <span class="sp-top-text">
                        <span @click="goBack">站点管理——</span>
                        <span>{{ schoolName }}</span>
                    </span>
                </div>
                <div class="fr add-par-enter-btn">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-button size="small" type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        <div class="yk-wrap-fixed wlx-site-manager-wrapper">
            <div class="wlx-table-content">
                <el-table :data="list" tooltip-effect="dark" style="width: 100%;">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="managerUserName" label="账号"></el-table-column>
                    <el-table-column prop="managerUserDisplayName" label="姓名"></el-table-column>
                    <el-table-column prop="type" label="类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 1">培训</span>
                            <span v-else-if="scope.row.type == 2">考核</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
                    <el-table-column label="操作" width="260">
                        <template slot-scope="scope">
                            <el-button size="mini" type="danger" class="el-icon-delete" @click="deleteSchoolManagerList(scope.row.id)" titlt="删除"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            ids: [],
            CreateDisplayName: "",
            hotelTitle: "",
            schoolName: "",
            dialogVisible: false,
            tosititle: "",
            form: {
                id: "",
                titlt: "",
                price: "",
                isBreakfast: "",
            },
        };
    },
    props: {
        schoolId: {
            type: String,
            default: "",
        },
    },
    created() {
        this.getSchoolManagerList(1);
    },
    methods: {
        getSchoolManagerList(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/SchoolManager/getSchoolManagerList", {
                    schoolId: this.schoolId,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.schoolName = rst.schoolName;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        deleteSchoolManagerList(id) {
            this.$confirm("此操作将删除该管理员, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var that = this;
                    this.$http
                        .post("/api/XOrg/SchoolManager/deleteSchoolManager", {
                            ids: id,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message({
                                    message: rst.msg,
                                    type: "success",
                                });
                                that.getSchoolManagerList(1);
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        goBack() {
            this.$router.push({
                name: "adoptSchool",
            });
        },
    },
};
</script>

<style lang="scss">
.yx-adopt-schoo-manager {
    background: #fff;
    padding-bottom: 20px;
    box-shadow: 0px 2px 4px 0px rgba(0, 70, 142, 0.14);
    .site-manager-head-con {
        height: 60px;
        background: #fff;
        border-bottom: 1px solid #f0f0f0;
        .top-page-top {
            border: none;
        }
        .add-par-enter-btn {
            margin: 13px 62px 0 0;
        }
    }
    .el-table thead {
        color: #05243D;
    }
    .sp-top-text {
        cursor: pointer;
    }
    .el-button-colour {
        padding: 6px 12px;
    }
}
</style>
